import { DialogProps } from '@liquidweb-dev/undercurrent/Dialog';
import Typography from '@liquidweb-dev/undercurrent/Typography';
import Link from '@liquidweb-dev/undercurrent/Link';
import Button from '@liquidweb-dev/undercurrent/Button';
import TrendingUpIcon from '@liquidweb-dev/undercurrent/icons/lucide/TrendingUp';
import DialogUTM from 'components/DialogUTM';
import useBrandName from 'utility/hooks/useBrandName';
// @ts-ignore
import GrowthScaleImg from 'images/utm/growth-scale-utm.png';
import { CAMPAIGN_VPS_GROWTH_SCALE } from '../DialogUTMWrapper';

const VPSContent = ({ isLiquidWeb }: { isLiquidWeb: boolean }) => (
	<Typography variant="body-md">
		Congrats on getting set up! Now it&apos;s time to expand.{' '}
		<Link
			href="https://docs.nexcess.com/hosting/hosting-services/cloud-vps/resize-a-cloud-server/"
			color="inherit"
			target="_blank"
			rel="noopener"
		>
			Resize your VPS
		</Link>{' '}
		or{' '}
		<Link
			href="https://docs.nexcess.com/hosting/performance/upgrades/dedicated-server-upgrades/"
			color="inherit"
			target="_blank"
			rel="noopener"
		>
			upgrade to a Dedicated Server
		</Link>{' '}
		for greater performance and flexibility.
		{isLiquidWeb && (
			<>
				<br />
				<br />
				Introduce your friends to Liquid Web and they&apos;ll receive a special
				discount on their hosting plan. Once they&apos;ve been with us for a
				short time, you&apos;ll earn hosting credits as our thank-you.
			</>
		)}
	</Typography>
);

const DedicatedContent = ({ isLiquidWeb }: { isLiquidWeb: boolean }) => (
	<Typography variant="body-md">
		You&apos;ve built a strong foundation, and now it&apos;s time to expand.{' '}
		<Link
			href="https://docs.nexcess.com/hosting/performance/upgrades/dedicated-server-upgrades/"
			color="inherit"
			target="_blank"
			rel="noopener"
		>
			Add more storage, security, or explore clusters to support larger
			workloads and future growth.
		</Link>
		{isLiquidWeb && (
			<>
				<br />
				<br />
				Introduce your friends to Liquid Web and they&apos;ll receive a special
				discount on their hosting plan. Once they&apos;ve been with us for a
				short time, you&apos;ll earn hosting credits as our thank-you.
			</>
		)}
	</Typography>
);

interface GrowthScaleProps extends Omit<DialogProps, 'onClose'> {
	onClose: () => void;
	campaign: string;
}

const GrowthScale = ({
	onClose,
	campaign,
	...dialogProps
}: GrowthScaleProps) => {
	const brandName = useBrandName();
	const isLiquidWeb = brandName === 'Liquid Web';

	return (
		<DialogUTM
			{...dialogProps}
			image={GrowthScaleImg}
			badge={{
				icon: TrendingUpIcon,
				label: 'Growth & Scale',
			}}
			dialogContent={{
				title:
					campaign === CAMPAIGN_VPS_GROWTH_SCALE
						? 'Grow your VPS and unlock more power'
						: 'Upgrade and grow your server',
				description:
					campaign === CAMPAIGN_VPS_GROWTH_SCALE ? (
						<VPSContent isLiquidWeb={isLiquidWeb} />
					) : (
						<DedicatedContent isLiquidWeb={isLiquidWeb} />
					),
			}}
			dialogAction={
				isLiquidWeb ? (
					<Link
						href="https://www.liquidweb.com/refer-a-friend/"
						target="_blank"
						rel="noopener"
						sx={{ width: 'fit-content' }}
					>
						<Button variant="secondary" size="medium">
							Refer A Friend
						</Button>
					</Link>
				) : undefined
			}
			onClose={onClose}
		/>
	);
};

export default GrowthScale;
